import Header from "@components/Header/Header"
import { useNavigate, useLocation } from "react-router"
import RewardImg from '@assets/images/RewardImg.png'
import { toCurrencyFormat } from "@lib/utils"
import ReferralStepNavigationItem from "@components/ReferralStepNavigationItem/ReferralStepNavigationItem"
import { RefereeInfo } from "../../types/referral"
import { useTranslation } from 'react-i18next'
import {
  Container,
  ContentContainer,
  ImageContainer,
  RewardImage,
  TitleContainer,
  TitleText,
  SubtitleText,
  StepsContainer,
  StepsTitle,
  StepsList
} from './ClaimReward.styles'
import { useEffect } from "react"
import { setHeaderColor } from "@lib/telegram"
import { WHITE } from "@styles/colors"

const ClaimReward = () => {
    const navigate = useNavigate()
    const { state } = useLocation()
    const { t } = useTranslation()
    const referralInfo = JSON.parse(state.refereeInfo) as RefereeInfo

    const reward = referralInfo.program_referee_reward_amount

    useEffect(() => {
        setHeaderColor(WHITE)
    }, [])

    return (
        <Container>
            <Header 
                title={t('components.claimReward.headerTitle')}
                onBackClick={() => navigate('/home')}
                showBackButton
            />
            <ContentContainer>
                <ImageContainer>
                    <RewardImage src={RewardImg} alt={t('components.claimReward.rewardImageAlt')} />
                </ImageContainer>
                <TitleContainer>
                    <TitleText>{t('components.claimReward.title')}</TitleText>
                    <SubtitleText>
                        {t('components.claimReward.subtitle', { amount: toCurrencyFormat(reward) })}
                    </SubtitleText>
                </TitleContainer>
                <StepsContainer>
                    <StepsTitle>{t('components.claimReward.stepsTitle')}</StepsTitle>
                    <StepsList>
                        {/* Steps */}
                        {referralInfo.steps.map((step) => (
                            <ReferralStepNavigationItem
                                key={step.title}
                                title={step.title}
                                description={step.description}
                                imgUrl={step.icon_url}
                                isCompleted={step.value >= referralInfo.steps_completed}
                                onClick={() => navigate(`/${step.navigate_to}`)}
                            />
                        ))}
                    </StepsList>
                </StepsContainer>
            </ContentContainer>
        </Container>
    )
}

export default ClaimReward